<ckeditor
    [editor]="classicEditor"
    [(ngModel)]="ckEditorContent"
    [config]="classicEditorItemsConfig"
    (change)="onChange($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (ready)="onReady($event)"
    [disabled]="isReadOnly"
    [ngClass]="{ 'ck-editor-error': hasLineLimitExceededError }"
>
</ckeditor>
